import { render } from "./ExportHospitals.vue?vue&type=template&id=e68757e2"
import script from "./ExportHospitals.vue?vue&type=script&lang=js"
export * from "./ExportHospitals.vue?vue&type=script&lang=js"

import "./ExportHospitals.vue?vue&type=style&index=0&id=e68757e2&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/ExportHospitals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e68757e2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e68757e2', __exports__)) {
    console.log('reload')
    api.reload('e68757e2', __exports__)
  }
  
  module.hot.accept("./ExportHospitals.vue?vue&type=template&id=e68757e2", () => {
    console.log('re-render')
    api.rerender('e68757e2', render)
  })

}


export default __exports__